import createAuthedClient from "./createAuthedClient";

const apiClient = createAuthedClient("/api");

export default apiClient;
